import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'states',
		loadChildren: () => import('app/modules/fund-management/states/states.module').then((m) => m.StatesModule),
	},
	{
		path: 'cash',
		loadChildren: () => import('app/modules/fund-management/cash-management/cash-management.module').then((m) => m.CashManagementModule),
	},
	{
		path: 'utilities',
		loadChildren: () => import('app/modules/fund-management/utilities/utilities.module').then((m) => m.UtilitiesModule),
	},
	{
		path: 'reports',
		loadChildren: () => import('app/modules/fund-management/reports/reports.module').then((m) => m.ReportsModule),
	},
	{
		path: 'accounts',
		loadChildren: () => import('app/modules/fund-management/accounts/accounts.module').then((m) => m.AccountsModule),
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class FundManagementRoutingModule {}
